import { apiClient } from './client.js';
import type { ProgramLeadInput } from '@atomfit/shared';

export const marketingApi = {
  unsubscribeStatus: (token: string) =>
    apiClient.get<{ email: string; unsubscribed: boolean }>('/marketing/unsubscribe', { params: { token } }),
  unsubscribe: (token: string) =>
    apiClient.post<{ unsubscribed: true }>('/marketing/unsubscribe', { token }),
  submitProgramLead: (input: ProgramLeadInput) =>
    apiClient.post<{ submitted: true }>('/marketing/program-leads', input),
};
